export default "__VITE_ASSET__BGJ$GeUG__"